import React from "react";
import Header from "./UIComponents/Header";
import Footer from "./UIComponents/Footer";
import Router from "./routes";
import { MainContainer } from "./styles";

function AppContainer() {
  return (
    <MainContainer className="main d-flex flex-column">
      <Header />
      <div
        className="flex-grow-1 d-flex flex-column w-100"
        style={{ minHeight: 0, flexShrink: 1 }}
      >
        <Router />
      </div>
      <Footer />
    </MainContainer>
  );
}

export default AppContainer;
